import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import { TextField, Button, Grid, Container } from '@material-ui/core'
import axios from 'axios'
import ControlledBackdrop from '../controlledBackdrop/backdrop.js'

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    width: '800px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}))

const currentDate = () => {
  const dateArray = Date().split(' ')
  let month = ''
  const day = dateArray[2]
  const year = dateArray[3]
  switch (dateArray[1]) {
    case 'Feb':
      month = '02'
      break
    case 'Mar':
      month = '03'
      break
    case 'Apr':
      month = '04'
      break
    case 'May':
      month = '05'
      break
    case 'Jun':
      month = '06'
      break
    case 'Jul':
      month = '07'
      break
    case 'Aug':
      month = '08'
      break
    case 'Sep':
      month = '09'
      break
    case 'Oct':
      month = '10'
      break
    case 'Nov':
      month = '11'
      break
    case 'Dec':
      month = '12'
      break
    default:
      month = '01'
  }
  return `${year}-${month}-${day}`
}
export default function OrModal (props) {
  const [file, setFile] = useState(null)
  const [orNo, setOrNo] = useState('')
  const [date, setDate] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = (e, obj, files) => {
    e.preventDefault()
    if (!obj.orNo.trim()) {
      alert('OR Number is required')
      return
    }
    if (!obj.orDate) {
      alert('Date is required')
      return
    }
    if (!files) {
      alert('File upload is required')
      return
    } else {
      const fileArray = files[0].name.split('.')
      const fileType = fileArray[fileArray.length - 1]
      if (fileType !== 'pdf') {
        alert('PDF file is required')
        return
      }
    }

    setIsLoading(true)
    let formData = new FormData()
    formData.set('crfForm', JSON.stringify(obj))
    formData.append('orUpload', files[0])
    axios({
      method: 'POST',
      url: `${process.env.REACT_APP_API_KEY}/api/orUpload`,
      data: formData,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130'
      }
    })
      .then(res => {
        if (res.data.data) {
          window.location.reload()
        } else {
          alert('Oops something went wrong')
          setIsLoading(false)
        }
      })
      .catch(err => {
        alert('Oops something went wrong')
        setIsLoading(false)
      })
  }

  const classes = useStyles()
  return (
    <div>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        className={classes.modal}
        open={props.modalState}
        onClose={props.handleModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Fade in={props.modalState}>
          <div className={classes.paper}>
            <h2 id='transition-modal-title'>OR Form</h2>
            <br />
            <Container>
              {' '}
              <ControlledBackdrop open={isLoading} />
              <form
                className={classes.root}
                noValidate
                autoComplete='off'
                onSubmit={e =>
                  handleSubmit(
                    e,
                    { crfNo: props.crfNo, orNo, orDate: date },
                    file
                  )
                }
              >
                <Grid
                  container
                  direction='column'
                  justify='center'
                  alignItems='left'
                  spacing={2}
                >
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id='filled-basic'
                      label='OR number'
                      value={orNo}
                      onChange={e => setOrNo(e.target.value)}
                      variant='outlined'
                      size='small'
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id='filled-basic'
                      type='date'
                      value={date}
                      onChange={e => setDate(e.target.value)}
                      onKeyDown={e => e.preventDefault()}
                      variant='outlined'
                      size='small'
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      id='filled-basic'
                      type='file'
                      onChange={e => setFile(e.target.files)}
                      variant='outlined'
                      size='small'
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid
                      container
                      direction='row'
                      justify='center'
                      alignItems='center'
                      spacing={0}
                    >
                      <Grid item xs={2}>
                        <Button variant='contained' type='submit'>
                          Save
                        </Button>
                      </Grid>
                      <Grid item xs={2}>
                        <Button
                          onClick={props.handleModal}
                          variant='contained'
                          color='secondary'
                        >
                          Cancel
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </Container>
          </div>
        </Fade>
      </Modal>
    </div>
  )
}
